/**
 * tasksense-capability-service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CapabilityFieldRecord } from './capabilityFieldRecord';


export interface CapabilityRecord { 
    code: string;
    version: string;
    description?: string;
    status: CapabilityRecord.StatusEnum;
    createdBy: string;
    createdAt: string;
    lastModifiedAt: string;
    fields?: Array<CapabilityFieldRecord>;
}
export namespace CapabilityRecord {
    export const StatusEnum = {
        InProgress: 'IN_PROGRESS',
        Active: 'ACTIVE',
        Inactive: 'INACTIVE',
        Decommissioned: 'DECOMMISSIONED'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


